import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fixed bottom-28 right-8 z-40 bg-white dark:bg-zinc-900 border-2 border-black dark:border-white shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.2)] p-4"
};
const _hoisted_2 = { class: "font-bold uppercase tracking-wider text-sm mb-4 text-center border-b border-black/10 dark:border-white/10 pb-3" };
const _hoisted_3 = { class: "flex flex-col gap-2" };
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "text-sm font-medium uppercase tracking-wide" };
import { ref, computed } from 'vue';
import { Icon } from '@iconify/vue';
import { SOCIAL_LINKS, CONTENT } from '../constants';
import { useLanguage } from '../composables/useLanguage';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SocialLinks',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        const isOpen = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" Toggle Button "),
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = !isOpen.value)),
                    class: _normalizeClass(["fixed bottom-8 right-8 z-50 bg-accent text-white w-14 h-14 flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300", { 'rotate-90': isOpen.value }])
                }, [
                    (isOpen.value)
                        ? (_openBlock(), _createBlock(_unref(Icon), {
                            key: 0,
                            icon: "ph:x-bold",
                            class: "w-6 h-6"
                        }))
                        : (_openBlock(), _createBlock(_unref(Icon), {
                            key: 1,
                            icon: "ph:share-network-bold",
                            class: "w-6 h-6"
                        }))
                ], 2 /* CLASS */),
                _createCommentVNode(" Social Links Menu "),
                _createVNode(_Transition, {
                    "enter-active-class": "transition-all duration-300",
                    "leave-active-class": "transition-all duration-300",
                    "enter-from-class": "opacity-0 translate-y-5 scale-95",
                    "leave-to-class": "opacity-0 translate-y-5 scale-95"
                }, {
                    default: _withCtx(() => [
                        (isOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("h5", _hoisted_2, _toDisplayString(text.value.social.title), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SOCIAL_LINKS), (link) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: link.name,
                                            href: link.url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            class: "flex items-center gap-3 px-4 py-3 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors duration-200 group"
                                        }, [
                                            _createVNode(_unref(Icon), {
                                                icon: link.icon,
                                                class: "w-5 h-5 text-accent"
                                            }, null, 8 /* PROPS */, ["icon"]),
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(link.name), 1 /* TEXT */),
                                            _createVNode(_unref(Icon), {
                                                icon: "ph:arrow-up-right-bold",
                                                class: "w-4 h-4 ml-auto opacity-0 group-hover:opacity-50 transition-opacity"
                                            })
                                        ], 8 /* PROPS */, _hoisted_4));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
